import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import {
  loadNoteflowExecutions,
  setNoteflowFilters,
  unsetNoteflowExecutions,
  unsetNoteflowFilters
} from '../../../store/actions/noteflowActions';
import { ApiParamsFilter } from '../../../models';
import SelectReportContainer from './SelectReportContainer';
import SelectUserContainer from './SelectUserContainer';
import ExecutionTimeframeContainer from './ExecutionTimeframeContainer';
import IsScheduleFilter from './IsScheduleFilter';

import './ExecutionFiltersContainer.scss';

interface IExecutionFiltersContainerProps {

}

const ExecutionFiltersContainer: FunctionComponent<IExecutionFiltersContainerProps> = ({

}: IExecutionFiltersContainerProps) => {
  const [ filters, setFilters ] = useState<ApiParamsFilter[] | null>(null);
  const dispatch = useDispatch();
  const hasFilters = (filters && filters.length > 0) || false;

  useEffect(() => {
    /*
     * on init, handle search params
     */
    const searchParams = new URLSearchParams(window.location.search);
    const reportUid = searchParams.get('report_uid');

    if (reportUid) {
      updateFilters('report', 'rel_r_nf', reportUid);
    }

    return () => {
      dispatch(unsetNoteflowFilters());
    };
  }, [ ]);

  useEffect(() => {
    if (filters) {
      dispatch(setNoteflowFilters(filters));
      dispatch(loadNoteflowExecutions({
        filters,
      }, true));
    }
  }, [ filters ]);

  const onRemoveFilters = () => {
    setFilters(null);
    dispatch(unsetNoteflowFilters());
    dispatch(unsetNoteflowExecutions());
  };

  const updateFilters = (col: string, opr: string, value: string | boolean) => {
    setFilters((oldFilters: any) => {
      const newFilters = oldFilters ? [...oldFilters] : [];
      const filterIndex = newFilters.findIndex((filter: any) => filter.col === col);

      if (filterIndex >= 0) {
        newFilters[filterIndex].value = value;
      } else {
        newFilters.push({ col, opr, value });
      }
      return newFilters;
    });
  }

  const onReportChange = (value: any) => {
    updateFilters('report', 'rel_r_nf', value.uid);
  };
  const onUserChange = (value: any) => {
    updateFilters('created_by', 'crel_o_m', value.uid);
  };
  const onTimeframeChange = (value: any) => {
    updateFilters('created_on', 'ltd', value.value); // less than days
  }
  const onIsScheduledChange = (value: boolean) => {
    if (value) {
      updateFilters('workflow_log', 'w_i_s', value);
    } else {
      setFilters((oldFilters: any) => {
        return oldFilters.filter((filter: any) => filter.col !== 'workflow_log'); // remove filter
      });
    }
  }

  return (
    <div className="execution-filters-container">
      <div className="execution-filters__flow-run">
        <div className="sidebar__header">
          <h4 className="title-text">Execution Log</h4>
          {
            (filters && filters.length > 0) && (
              <Button
                className="execution-filters__flow-run__header__clear-filters"
                minimal={true}
                icon={IconNames.FILTER_REMOVE}
                onClick={onRemoveFilters}
                title="Clear filters"
              />
            )
          }
        </div>
        <div className="execution-filters__flow-run__filters">
          <SelectReportContainer
            onChange={onReportChange}
            reset={!hasFilters}
          />
          <SelectUserContainer
            onChange={onUserChange}
            reset={!hasFilters}
          />
          <ExecutionTimeframeContainer
            onChange={onTimeframeChange}
            reset={!hasFilters}
          />
          <IsScheduleFilter
            onChange={onIsScheduledChange}
            reset={!hasFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default ExecutionFiltersContainer;
